module.exports = __webpack_public_path__ + "img/23.3.TP.5a99c997.png";